import { Box } from "@mui/material";
import React from "react";
import { Captain } from "../../../types/Captain";
import ScrollAnimationWrapper from "../../layouts/Animations/ScrollAnimationWrapper";
import StatisticItem from "./StatisticItem";
import {
    contentWrapper,
    lottieWrapper,
    statisticsContainer,
} from "./statisticsStyles";

interface StatisticsProps {
    statistics: Captain["statistics"];
    lottieAnimationData: any;
    lottieAnimationData2?: any;
    videoEnded: boolean;
}

const StatisticsV2: React.FC<StatisticsProps> = ({ statistics }) => {
    if (!statistics) return null;

    return (
        <Box sx={statisticsContainer}>
            <Box sx={contentWrapper}>
                {statistics.length >= 1 && (
                    <ScrollAnimationWrapper>
                        <Box sx={lottieWrapper}></Box>
                    </ScrollAnimationWrapper>
                )}

                <Box>
                    {statistics.map((stat, index) => (
                        <ScrollAnimationWrapper key={index}>
                            <StatisticItem
                                statisticName={stat.statisticName}
                                statisticValue={stat.statisticValue}
                                statisticDescription={stat.statisticDescription}
                            />
                        </ScrollAnimationWrapper>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default StatisticsV2;
